import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { DayBarChart } from "~/components/day-bar-chart";
import {
  type DayCount,
  fillDateGaps,
  chartDateRange,
} from "~/lib/shared/day-chart";
import { purple } from "~/lib/ui";

export const getSessionsByDay = createServerFn({ method: "GET" }).handler(
  async (): Promise<Array<DayCount>> => {
    const { getDBWithInit } = await import("~/lib/db");
    const { sessions } = await import("~/../drizzle/schema");
    const { sql, and, gte, lt } = await import("drizzle-orm");

    const { rangeStart, rangeEnd } = chartDateRange(21, 14);
    const db = await getDBWithInit();

    const rows = await db
      .select({
        date: sql<string>`DATE(${sessions.startAt})`.as("date"),
        count: sql<number>`COUNT(*)::int`.as("count"),
      })
      .from(sessions)
      .where(
        and(gte(sessions.startAt, rangeStart), lt(sessions.startAt, rangeEnd)),
      )
      .groupBy(sql`DATE(${sessions.startAt})`)
      .orderBy(sql`DATE(${sessions.startAt})`);

    return fillDateGaps(rows, {
      daysBefore: 21,
      daysAfter: 14,
      pastColor: purple[500],
      futureColor: purple[300],
    });
  },
);

function SessionsChartPage() {
  const { data } = Route.useLoaderData();
  return (
    <DayBarChart
      data={data}
      noun="Sessions"
      rangeLabel="3 weeks ago to 2 weeks ahead"
    />
  );
}

export const Route = createFileRoute("/embed/sessions-chart/")({
  head: () => ({
    title: "Sessions Chart - Dream Coach Match",
    meta: [
      {
        name: "description",
        content: "Embedded chart showing scheduled coaching sessions over time",
      },
    ],
  }),
  loader: async () => {
    const data = await getSessionsByDay();
    return { data };
  },
  component: SessionsChartPage,
});
